export type JobsOfferType = {
  vidGridId?: string | null;
  showVideo?: boolean;
  jobId?: number;
  title?: string;
  companyName?: string;
  applyUrl?: string;
  createdUtc: string;
  publishedDate?: string;
  description?: string;
  displayUrl?: string;
  jobLocation?: string;
  jobCode?: string;
  listUrl: string;
  requirements?: string;
  salaryDescription?: string | null;
  hiringDepartment?: string | null;
  jobTypes?: string;
  jobTypesArray?: Array<string>;
  sectionId?: string;
};

export type JobsByTeamResult = {
  teams: {
    [index: string]: Array<JobsOfferType>;
  };
  error?: string;
};

const groupByKey = (list, key) =>
  list.reduce(
    (hash, obj) => ({
      ...hash,
      [obj[key]]: (hash[obj[key]] || []).concat(obj),
    }),
    {},
  );

const refactorJobsListObject = jobsList => {
  if (jobsList?.length > 0) {
    const jobs = jobsList.map(
      ({
        title,
        description,
        requirements,
        jobLocation,
        applyUrl,
        jobId,
        hiringDepartment,
      }) => {
        return {
          title,
          hiringDepartment,
          description: description.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, ''),
          requirements: requirements.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, ''),
          jobLocation: jobLocation.locationDisplayName,
          applyUrl,
          sectionId: title.replace(/[^A-Z0-9]+/gi, '-').toLowerCase(),
          jobId,
        };
      },
    );
    return jobs;
  }
  return null;
};

const jobsEndpoint = `${process.env.NEXT_PUBLIC_PAYLOCITY_API_URL}/${process.env.NEXT_PUBLIC_PAYLOCITY_API_KEY}`;

export async function getJobsByTeam(): Promise<JobsByTeamResult> {
  const response = await fetch(jobsEndpoint);
  const jobsList = await response.json();
  let error = null;
  let teams = null;

  if (jobsList['message']) {
    error = jobsList['message'];
  } else {
    const jobs = refactorJobsListObject(jobsList?.jobs);
    if (jobs?.length > 0) {
      teams = groupByKey(jobs, 'hiringDepartment');
    }
  }

  return {
    teams,
    error,
  };
}
